import { Box, Button, Loading } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SalesDocumentTemplateLoadingModalProps {
  title: string
  onClose: () => void
}

export const SalesDocumentTemplateLoadingModal = ({
  title,
  onClose,
}: SalesDocumentTemplateLoadingModalProps) => {
  return (
    <Modal
      illustration="template"
      title={title}
      description={i18n.t('common.loading')}
      onClose={onClose}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.cancel')}
        </Button>
      }
    >
      <Box flexDirection="column" alignItems="center" justifyContent="center">
        <Loading />
      </Box>
    </Modal>
  )
}
